import React, { useState, useEffect } from "react";
import Layout from "containers/Layout";
import "react-dropdown/style.css";

import { Headersub } from "../../GenericComponent/HeaderSub/headersub";
import { TableDanhSach } from "./TableDanhSach";
import { SearchBarDesktop } from "./SearchBar/SearchBarDesktop";
import { SearchBarMobile } from "./SearchBar/SearchBarMobile";

import StoreApi from "service/phanQuyenApi";
import LayoutV2 from "containers/LayoutV2";
export const HopDongChoDuyet = (props) => {
  const initPhanQuyen = {
    hopdongchoduyet: false,
    hopdongchoduyet_duyetchoduyet: false,
    hopdongchoduyet_xacnhangiaotien: false,
    hopdongchoduyet_suachoduyet: false,
    hopdongchoduyet_xoachoduyet: false,
    hopdongchoduyet_chitiethopdong: false,
    hopdongchoduyet_chitietkhachhang: false,
    SuDungPhiPhat_DongLai_TatToan: false,
    SuDungPhiPhat_DongLai_Cham: false,
    SuDungCongTacVienNhanVien: false,
    SuDungTatToanSom: false,
  };
  const [phanQuyen, setPhanQuyen] = useState(initPhanQuyen);

  useEffect(() => {
    document.title = "Hợp đồng chờ duyệt | Phần mềm quản lý cầm đồ Morman";
    LoadPhanQuyen();
  }, []);

  const LoadPhanQuyen = () => {
    StoreApi.phanQuyenHopDongChoDuyet().then((response) => {
      setPhanQuyen({
        ...phanQuyen,
        hopdongchoduyet: response.data.hopdongchoduyet,
        hopdongchoduyet_duyetchoduyet:
          response.data.hopdongchoduyet_duyetchoduyet,
        hopdongchoduyet_xacnhangiaotien:
          response.data.hopdongchoduyet_xacnhangiaotien,
        hopdongchoduyet_suachoduyet: response.data.hopdongchoduyet_suachoduyet,
        hopdongchoduyet_xoachoduyet: response.data.hopdongchoduyet_xoachoduyet,
        hopdongchoduyet_chitiethopdong:
          response.data.hopdongchoduyet_chitiethopdong,
        hopdongchoduyet_chitietkhachhang:
          response.data.hopdongchoduyet_chitietkhachhang,
        SuDungPhiPhat_DongLai_TatToan:
          response.data.SuDungPhiPhat_DongLai_TatToan,
        SuDungPhiPhat_DongLai_Cham: response.data.SuDungPhiPhat_DongLai_Cham,
        SuDungCongTacVienNhanVien: response.data.SuDungCongTacVienNhanVien,
        SuDungTatToanSom: response.data.SuDungTatToanSom,
      });
    });
  };
  return (
    <LayoutV2>
      {phanQuyen.hopdongchoduyet && (
        <div id="form-repeater">
          <div className="sticky-moman-bh">
            <div className="col-12">
              <div className="camdo-home">
                <div className="breadcrumb-new mb-1">
                  <div className="row">
                    <div className="col-sm-12 col-md-12 title-cd">
                      <div className="media-home align-center-home">
                        <div class="row header">
                          {/* <div className="col-sm-6"> */}
                          <img
                            className="icon-bred-home"
                            src="/app-assets/images/logo-cam-do-v2.png"
                            alt=""
                          />
                          <h1 className="text-info-home">Hợp đồng chờ duyệt</h1>
                          {/* </div> */}
                          {/* <div className="col-sm-6"></div> */}
                        </div>
                      </div>
                    </div>
                  </div>{" "}
                </div>{" "}
                <div className="card border-light mb-1 hidden-mobile-main show-table-main card-v2">
                  <div className="card-body card-body-v2">
                    <SearchBarDesktop />
                    <SearchBarMobile />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <TableDanhSach
            quyenDuyet={phanQuyen.hopdongchoduyet_duyetchoduyet}
            quyenXacNhan={phanQuyen.hopdongchoduyet_xacnhangiaotien}
            quyenSua={phanQuyen.hopdongchoduyet_suachoduyet}
            quyenXoa={phanQuyen.hopdongchoduyet_xoachoduyet}
            quyenChiTietHopDong={phanQuyen.hopdongchoduyet_chitiethopdong}
            quyenChiTietKhachHang={phanQuyen.hopdongchoduyet_chitietkhachhang}
            showFormTraGop={props.showFormTraGop}
            showFormTinChap={props.showFormTinChap}
            inthuchi={props.inthuchi}
            phanquyen={props.phanquyen}
            showFormCamDo={props.showFormCamDo}
            showModalLoaiTaiSan={props.showModalLoaiTaiSan}
            loaitaisan={props.loaitaisan}
            isDuDungPhiPhatDongLaiTatToan={
              phanQuyen.SuDungPhiPhat_DongLai_TatToan
            }
            SuDungPhiPhat_DongLai_Cham={phanQuyen.SuDungPhiPhat_DongLai_Cham}
            isSuDungCongTacVienNhanVien={phanQuyen.SuDungCongTacVienNhanVien}
            isSuDungTatToanSom={phanQuyen.SuDungTatToanSom}
          />
        </div>
      )}
      {!phanQuyen.hopdongchoduyet && (
        <div id="form-repeater">
          <div className="sticky-moman-bh">
            <div className="col-12">
              <div className="camdo-home">
                <div className="breadcrumb-new mb-1">
                  <div className="row">
                    <div className="col-sm-12 col-md-12 title-cd">
                      <div className="media-home align-center-home">
                        <div class="row header">
                          {/* <div className="col-sm-6"> */}
                          <img
                            className="icon-bred-home"
                            src="/app-assets/images/logo-cam-do-v2.png"
                            alt=""
                          />
                          <h1 className="text-info-home">Hợp đồng chờ duyệt</h1>
                          {/* </div> */}
                          {/* <div className="col-sm-6"></div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <span
            style={{
              textAlign: "center",
              color: "red",
              display: "flex",
              justifyContent: "center",
            }}
          >
            Bạn không có quyền truy cập chức năng này.
          </span>
        </div>
      )}
    </LayoutV2>
  );
};
